// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop-module__Backdrop__2cVmF","AnimateBackdrop":"Backdrop-module__AnimateBackdrop__3AqIO","fadeInFromNone":"Backdrop-module__fadeInFromNone__2F5DT","BackdropCarousel":"Backdrop-module__BackdropCarousel__1VQoY","Unsubscribe":"Backdrop-module__Unsubscribe__3qswt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Backdrop/Backdrop.module.css
// module id = 1694
// module chunks = 31